/** Keeps password managers from offering saved logins for a field or storing it. */ export const passwordManagerIgnoreProps = {
    "data-1p-ignore": true,
    "data-lpignore": "true",
    "data-form-type": "other"
};

//# sourceMappingURL=password-manager-ignore.js.map